module.exports = __webpack_public_path__ + "static/media/bell-church2.8c31d6ec.aac";